import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { EntryTypeService } from "../report-services/entry-type.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";
import { GradeLevelService } from "../report-services/grade-level.service";
import { GroupService } from "../report-services/group.service";
import { HomeroomService } from "../report-services/homeroom.service";

@Component({
	templateUrl: "./entrytypecounts.component.html",
})
export class EntryTypeCountsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private gradelevelService: GradeLevelService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private entrytypeService: EntryTypeService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		EntryTypeID: 0,
		GradeLevelID: 0,
		GroupID: 0,
		HomeroomID: 0,
		STARTDATE: new Date(),
		ENDDATE: new Date(),
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	EntryTypeList: any = [];
	GradeLevelList: any = [];
	GroupList: any = [];
	HomeroomList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 149;
	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadEntryTypeList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadEntryTypeList();
		this.loadGradeLevelList();
		this.loadHomeroomList();
		this.loadGroupList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(149);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadEntryTypeList() {
		this.report.EntryTypeID = 0;
		var result = this.entrytypeService.loadEntryTypeList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.EntryTypeList = response;

				if (this.EntryTypeList.length > 1) {
					this.EntryTypeList.unshift({
						EntryTypeID: 0,
						EntryTypeDesc: "All EntryTypes",
					});
				} else {
					this.report.EntryTypeID = this.EntryTypeList[0].EntryTypeID;
				}
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length > 1) {
					// this.HomeroomList.unshift({
					//     HomeroomId: 0,
					//     HomeRoom: "All Homerooms"
					// })
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				}
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length > 1) {
					// this.GroupList.unshift({
					//     GroupID: 0,
					//     GroupName: "All Groups"
					// })
					this.report.GroupID = this.GroupList[0].GroupID;
				} else {
					this.report.GroupID = this.GroupList[0].GroupID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.EntryTypeID) {
		// 	this.errorMessage = "Select the EntryType"
		// 	return;
		// }

		// if (!this.report.STARTDATE) {
		// 	this.errorMessage = "Select the STARTDATE"
		// 	return;
		// }

		// if (!this.report.ENDDATE) {
		// 	this.errorMessage = "Select the ENDDATE"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 149;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: EntryTypeID
		strParam += "," + this.report.EntryTypeID + "|EntryTypeID";

		//Parameter 3: STARTDATE
		strParam += "," + moment(this.report.STARTDATE).format("MM/DD/YYYY") + "|STARTDATE";

		//Parameter 4: ENDDATE
		strParam += "," + moment(this.report.ENDDATE).format("MM/DD/YYYY") + "|ENDDATE";

		//Parameter 5: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 6: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 7: HomeroomID
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		//Parameter 8: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
